<template>
<div>
    <show-signature-modal
        :signature="is_resolution ? form_submission?.resolution?.signature : form_submission?.signature"
        :user="is_resolution ? form_submission?.resolution?.signature?.user : form_submission?.signature?.user"
        ref="signature_modal"
    />

    <!-- Resolution -->
    <div
        v-if="form_submission.resolution"
        class="form-submission-card"
        :class="spacingClass"
    >
        <submission-title :form_status="getFormStatus(form_submission.resolution)" />

        <submission-subtitle
            :signature="form_submission.resolution.signature"
            :form_status="getFormStatus(form_submission.resolution)"
            :pdf_mode="pdf_mode"
            @open-signature="openSignature(true)"
        />

        <div class="form-submission-card-content">
            <div
                v-if="hasCommentsOrPhotos(form_submission.resolution)"
                class="form-submission-card-content-child"
            >
                <gallery-view-component :photos="form_submission.resolution.photos" />

                <response-comments
                    v-if="form_submission.resolution.comments"
                    :comments="form_submission.resolution.comments"
                    is_nested
                />
            </div>

            <custom-form-answer-submission
                v-for="(answer, index) in form_resolution_question_answers"
                :key="`resolution_${index}`"
                :answer="answer"
            />

            <list-of-operatives-signatures
                class="form-submission-card-content-child"
                :data="form_submission.resolution.signatures"
                :inline_signature="pdf_mode"
                :show_url="show_url"
                is_nested
            />
        </div>
    </div>

    <!-- Submission -->
    <div
        class="form-submission-card"
        :class="spacingClass"
    >
        <submission-title :form_status="getFormStatus(form_submission)" />

        <submission-subtitle
            :signature="form_submission?.signature"
            :form_status="getFormStatus(form_submission)"
            :pdf_mode="pdf_mode"
            @open-signature="openSignature(false)"
        />

        <div class="form-submission-card-content">
            <custom-form-answer-submission
                v-for="answer in form_question_answers"
                :key="answer.id"
                :answer="answer"
            />

            <div
                v-if="hasCommentsOrPhotos(form_submission)"
                class="form-submission-card-content-child"
            >
                <response-comments
                    v-if="form_submission.comments"
                    :comments="form_submission.comments"
                    is_nested
                />

                <gallery-view-component :photos="form_submission.photos" />
            </div>

            <list-of-operatives-signatures
                :data="form_submission.signatures"
                :inline_signature="pdf_mode"
                :show_url="show_url"
                is_nested
            />
        </div>
    </div>
</div>
</template>

<script>
import CustomFormAnswerSubmission from "./CustomFormAnswerSubmission";
import GalleryViewComponent from "../general_components/GalleryViewComponent";
import ShowSignatureModal from "../modals/ShowSignatureModal";
import SubmissionSubtitle from "./SubmissionSubtitle";
import SubmissionTitle from "./SubmissionTitle";
import ResponseComments from "./responses/ResponseComments";
import ListOfOperativesSignatures from "../forms/ListOfOperativesSignatures.vue";

export default {
    components: {
        CustomFormAnswerSubmission,
        GalleryViewComponent,
        ListOfOperativesSignatures,
        ShowSignatureModal,
        SubmissionSubtitle,
        SubmissionTitle,
        ResponseComments,
    },
    props: {
        form_submission: {
            type: Object,
            required: true,
        },
        show_url: {
            type: String,
            required: true,
        },
        pdf_mode: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            is_resolution: false
        }
    },
    methods: {
        openSignature(is_resolution = false) {
            this.is_resolution = is_resolution;
            this.$refs.signature_modal.open();
        },
        hasCommentsOrPhotos(submission) {
            return submission?.comments ||
                (submission?.photos && Object.keys(submission.photos).length >= 1)
                ;
        },
        getFormStatus(submission) {
            return submission?.form_status;
        },
    },

    computed: {
        form_question_answers() {
            let question_answers = Object.assign([], this.form_submission.answers);
            return question_answers.sort((a, b) => a.question.order > b.question.order ? 1 : -1);
        },

        form_resolution_question_answers() {
            let question_answers = Object.assign([], this.form_submission.resolution.answers);
            return question_answers.sort((a, b) => a.question.order > b.question.order ? 1 : -1);
        },

        spacingClass() {
            return this.pdf_mode ? 'm-0 p-0' : '';
        }
    }
}
</script>
